module.exports = __webpack_public_path__ + "themes/mf/img/multiplier-x2@2x.png";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/img/multiplier-x2@2x.png
// module id = 83
// module chunks = 3